<template>
  <b-table :data="products" hoverable>
    <b-table-column
      field="b"
      label="Código de barras"
      sortable
      searchable
      v-slot="props"
    >
      {{ props.row.b }}
    </b-table-column>

    <b-table-column field="n" label="Nome" sortable searchable v-slot="props">
      {{ props.row.n }}
    </b-table-column>

    <b-table-column field="p" label="Preço" sortable v-slot="props">
      R$ {{ formatMoney(props.row.p) }}
    </b-table-column>

    <b-table-column field="p" label="Qtd Atual" sortable v-slot="props">
      {{ props.row.cq }}
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>Nenhum produto ainda...</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { mask } from "../../mixins/mask";

export default {
  props: ["products", "storeBeingManaged"],

  mixins: [mask]
};
</script>
